module.exports = __webpack_public_path__ + "static/media/placeholder-group.758004c8.webp";